import { render, staticRenderFns } from "./DocumentCommentEditForm.vue?vue&type=template&id=0d2eeb60&"
import script from "./DocumentCommentEditForm.vue?vue&type=script&lang=js&"
export * from "./DocumentCommentEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports